import { OfferServiceTypeEnum } from './enums/offer-service-type.enum';

export class ServiceType {
  code!: string;
  labelKey!: string;
  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_SERVICE_TYPE: { [key: string]: ServiceType } = {
  LTL: new ServiceType({ code: OfferServiceTypeEnum.LTL, labelKey: '' }),
  FTL: new ServiceType({ code: OfferServiceTypeEnum.FTL, labelKey: '' }),
  QUOTATION: new ServiceType({ code: OfferServiceTypeEnum.QUOTATION, labelKey: '' }),
};
